import {createAction, props} from '@ngrx/store';
import {Region} from '../../../core/models/region';

export const getRegions = createAction(
  '[Core] Get Regions',
);

export const getRegionsSuccess = createAction(
  '[Core/API] Get Regions Success',
  props<{regions: Region[]}>()
);

export const getRegionsFailure = createAction(
  '[Core/API] Get Regions Success',
  props<{error: any}>()
);

export type RegionActionsUnion = ReturnType<
  typeof getRegions |
  typeof getRegionsSuccess |
  typeof getRegionsFailure
  >;
